import './index.css';

class Tooltip {
    constructor (props) {
        this.props = {
            parent: document.getElementById('tooltip-root'),
            tooltip: document.createElement('div'),
            title: props.message || '',
            theme: props.theme || 'basic', // error, info
            coordinates: props.coordinates
        };

        this.props.tooltip.onmouseleave = this.hide.bind(this);
        this.props.tooltip.className = `Tooltip ${this.props.theme}`;
        this.setMessage(props.message);
    }

    setMessage (message) {
        this.props.tooltip.innerHTML = message;
    }

    show (props = {}) {
        const coordinates = props.coordinates || this.props.coordinates;
        if (props.title)
            this.setMessage(props.title);

        this.props.parent.appendChild(this.props.tooltip);
        const tooltip = this.props.tooltip.getBoundingClientRect();
        let top = coordinates.top - tooltip.height - 5;
        let left = coordinates.left + (coordinates.width / 2) - (tooltip.width / 2);

        if (left < 10)
            left = 10;
        if (top < 0)
            top = 0;

        this.props.tooltip.style.top = `${top}px`;
        this.props.tooltip.style.left = `${left}px`;
    }

    hide () {
        try {
            this.props.parent.removeChild(this.props.tooltip);
        } catch (e) {
        }
    }
}

export default Tooltip;